import React from 'react';

const Input = ({ 
  label, 
  type = 'text', 
  value, 
  onChange, 
  placeholder, 
  helpText,
  required = false,
  style = {},
  ...props 
}) => {
  const inputStyle = {
    width: '100%',
    padding: '12px 16px',
    border: '2px solid #e1e5e9',
    borderRadius: '8px',
    fontSize: '1rem',
    transition: 'border-color 0.3s ease',
    boxSizing: 'border-box',
    ...style
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '8px',
    fontWeight: 'bold',
    color: '#333',
    fontSize: '1rem',
  };

  const helpTextStyle = {
    display: 'block',
    marginTop: '5px',
    color: '#666',
    fontSize: '0.9rem',
    lineHeight: '1.4',
  };

  return (
    <div>
      {label && (
        <label style={labelStyle}>
          {label}
          {required && <span style={{ color: '#dc3545' }}> *</span>}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={inputStyle}
        {...props}
      />
      {helpText && (
        <small style={helpTextStyle}>
          {helpText}
        </small>
      )}
    </div>
  );
};

export default Input;
